/**
 * Format odd to american format
 * @param {string} decimalOutcome - original odd number as string
 */
function toAmerican(decimalOutcome) {
  let decimal = parseFloat(decimalOutcome);
  let convertedOdd = 0;
  if (isNaN(decimal) || decimal <= 1) {
    return '--';
  }

  if (decimal < 2) {
    convertedOdd = -100 / (decimal - 1);
  } else {
    convertedOdd = (decimal - 1) * 100;
  }
  convertedOdd = (convertedOdd > 0 ? '+' : '') + Math.round(Math.round(convertedOdd * 100) / 100);

  return convertedOdd;
}

/**
 * Format odd to fractional format
 * @param {string} decimalOutcome - original odd number as string
 */
function toFractional(decimalOutcome) {
  let decimal = parseFloat(decimalOutcome);
  if (isNaN(decimal) || decimal <= 1) {
    return '--';
  }
  decimal -= 1;
  let bestFrac = `${Math.round(decimal)}/1`;
  let bestFracVal = Math.round(decimal);
  let myBestErr = Math.abs(bestFracVal - decimal);
  for (let i = 2; i <= 200; i += 1) {
    let myFracVal = Math.round(decimal * i) / i;
    let myErr = Math.abs(myFracVal - decimal);
    if (myErr < myBestErr) {
      bestFrac = `${Math.round(decimal * i)}/${i}`;
      bestFracVal = myFracVal;
      if (myErr === 0) break;
      myBestErr = myErr;
    }
  }
  return bestFrac;
}

/**
 * Format odds 
 * @param {string} decimalOutcome - original odd number as string
 * @param {string} [format] - optional formater
 */
export const formatOddDisplay = (decimalOutcome, format) => {
  const float = parseFloat(decimalOutcome);
  if (decimalOutcome === null || !float || float === 0 || float === 1) {
    return '--';
  }
  let convertedOdd = decimalOutcome;
  let userSelectedFormat = format || localStorage.getItem('oddFormat');
  let formatting = userSelectedFormat || APP_SETTINGS.formatting.outcomeType;
  switch (formatting) {
    case 'fractional':
      convertedOdd = toFractional(decimalOutcome);
      break;
    case 'american':
      convertedOdd = toAmerican(decimalOutcome);
      break;
    default:
      convertedOdd = float.toFixed(2);
      break;
  }
  return convertedOdd;
}

/**
 * Format number as currency
 * @param {string} val - amount to format as currency
 * @param {string} [curCode] - optional currency code 
 */
export function formatCurrency(val, curCode = '') {
  const currencyDisplay = APP_SETTINGS.currencyFormat.currencyDisplay;
  const invalidNum = isNaN(val) || `${val}`.trim() === '';
  // display only the amount without currency
  if (currencyDisplay === 'none') {
    return invalidNum ? ' -- ' : val;
  }
  let playerCurrency = APP_SETTINGS.player.currency;
  // if currency code is sent as parametar then use that currency Code
  if (curCode !== '') {
    playerCurrency = curCode;
  }
  // if custom culture is not set in the settings use the language code for formating the currency display
  let culture = APP_SETTINGS.locale || APP_SETTINGS.player.language;
  if (APP_SETTINGS.currencyFormat.currencyCulture) {
    culture = APP_SETTINGS.currencyFormat.currencyCulture;
  }
  let num = invalidNum ? '--' : parseFloat(val).toFixed(APP_SETTINGS.currencyFormat.rd);
  let amountString = `${num}  ${playerCurrency}`;
  // format the currency display acording to the culture or language
  if (APP_SETTINGS.currencyFormat.localizedDisplay === true && playerCurrency !== '') {
    amountString = parseFloat(val).toLocaleString(culture, {
      style: 'currency',
      currency: playerCurrency,
      currencyDisplay,
      useGrouping: APP_SETTINGS.currencyFormat.useGrouping,
      minimumFractionDigits: APP_SETTINGS.currencyFormat.rd,
      maximumFractionDigits: APP_SETTINGS.currencyFormat.rd,
    }).replace('NaN', ' -- ');
  }
  return amountString;
}